//#region src/version.ts
const version = "5.2.0";

//#endregion
export { version };
//# sourceMappingURL=version.js.map